// extracted by mini-css-extract-plugin
export default {"dashMenuTail":"dashMenuTail__U4T4Tm","dashMenuSmallTail":"dashMenuSmallTail__O1oMfY","dashMenu":"dashMenu__kQ1_mL"};